module.exports = __webpack_public_path__ + "images/iphone-gbi-mockup@2x_9712eae.png";